import { notifications } from "@mantine/notifications";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "State/store";

const AdminRouteGuard = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();
  const { adminToken, isAdminLoggedIn } = useSelector(
    (state: RootState) => state.adminlogin
  );

  
  const wasLoggedInRef = useRef(false);

  useEffect(() => {
    if (adminToken && isAdminLoggedIn) {
      wasLoggedInRef.current = true;
      return;
    }


    navigate("/admin-login");
  }, [adminToken, isAdminLoggedIn, navigate]);

  return adminToken && isAdminLoggedIn ? children : null;
};

export default AdminRouteGuard;
